import classNames from "classnames";
import { SanityRawContent } from "../../../model/common";
import BlockContent from "../../BlockContent/BlockContent";
import { Col, Row, Wrapper } from "../../Grid";
import React from "react";
import styles from "./SupplimentaryContent.module.scss";

const SupplimentaryContent = ({ content }: { content: SanityRawContent }) => {
  return (
    <Wrapper className={classNames(styles.root, styles.noPaddingMobile)}>
      <Row justify="center" className={styles.mainContentRow}>
        <Col sm={10} md={8} lg={7}>
          <BlockContent content={content} cap="none" />
        </Col>
      </Row>
    </Wrapper>
  );
};

export default SupplimentaryContent;
